import React, { useRef, useState } from 'react'
import { WrapMarkWordsContent, DrawerStyles, WrapMarkWords, WrapScreenMarkWords, WrapCustomSection, WordsContentStyles } from './Style'
import { useLocation } from 'react-router-dom'
import { components } from 'keys'
import { Header, ErrorTypes, wordHooks } from 'pages/Words'
import { Stepper } from 'components/School/MakingRecordAssessments'
import { IconButton, useMediaQuery } from '@mui/material'
import { Img } from 'styles/GlobalStyle'
import { CacheProvider } from '@emotion/react'
import { cacheLtr } from 'styles/theme'
import { Close, Pause, PlayArrow } from '@mui/icons-material'
import { Point } from 'assets'
import { AnimatePresence } from "motion/react"
import * as motion from "motion/react-client"

const WordsContent = (props) => {
    const { cartoonSpeaking, handleCartoonSpeaking, showCartoon, contentToPrint, disabled, student, type, words, settings, comment } = props

    const { state = {} } = useLocation();

    const studentView = student || state?.student

    const assessmentCategory = wordHooks.useAssessmentCategory()

    let category = assessmentCategory[type || "DEFAULT"]
    const Component = studentView ? category.student?.component : category.component

    return (
        <WordsContentStyles student={student} ref={contentToPrint}>
            <WrapMarkWordsContent student={student} $disabled={disabled}>
                {/* {student && showCartoon &&
                    <div className='wrap-speaker-cartoon'>
                        <AnimatePresence>
                            <motion.div
                                initial={{ y: '100vh', x: '100vw', opacity: 0 }} // מתחיל מחוץ למסך משמאל
                                animate={{ y: 1, x: 1, opacity: 1 }} // נכנס למקום שלו
                                exit={{ x: '-100vw', opacity: 0 }} // יוצא מהמסך משמאל
                                transition={{ duration: 1 }} // משך האנימציה
                                className='cartoon-img'
                            >
                                <div className='speaker-cartoon'>
                                    <Img src={Point} />
                                </div>
                                <div className='play-pause-cartoon'>
                                    <IconButton onClick={handleCartoonSpeaking}>
                                        {cartoonSpeaking ? <Pause color="thirdly" /> : <PlayArrow color="thirdly" />}
                                    </IconButton>
                                </div>
                            </motion.div>
                        </AnimatePresence>
                    </div>
                } */}
                <WrapCustomSection
                    $fullHeight={studentView && category?.student?.fullHeight}
                    $noShadow $bg={false} align="center" $flex $column>
                    <AnimatePresence>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: student ? 9 : 0.7 }}
                            style={{ width: "100%", height: "100%" }}
                        >
                            <Component visibleType={type} words={words} settings={settings} comment={comment} />
                        </motion.div>
                    </AnimatePresence>
                    <Stepper />
                </WrapCustomSection>
            </WrapMarkWordsContent>
        </WordsContentStyles>
    )
}

const Words = (props) => {
    const { hideNextButton, hideDisabledNext = false, changeBoldWordAfterSeconds, boldWordAfterSeconds, initialPage, handleNext, finishPerfom, showErrorTypes, showCartoon, words, type, settings, disabled, student, comment } = props
    const [open, setOpen] = useState(false);
    const [wordListPage, setWordListPage] = useState(0);
    const [wordListIndex, setWordListIndex] = useState(0);
    const { state = {} } = useLocation();
    const contentToPrint = useRef(null);

    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'), { noSsr: true })

    const { header = props.header, footer = props.footer } = state || {}

    const commonState = {
        words,
        hideDisabledNext,
        settings,
        wordListPage, setWordListPage,
        wordListIndex, setWordListIndex,
        finishPerfom,
        showCartoon,
        handleNext,
        initialPage,
        hideNextButton,
        boldWordAfterSeconds, changeBoldWordAfterSeconds
    }

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpen(open);
    };

    return (
        <WordsContext.Provider value={commonState}>
            <WrapScreenMarkWords student={student}>
                {student || <Header {...props} toggleDrawer={toggleDrawer} contentToPrint={contentToPrint} />}
                {components?.[header]}
                {showErrorTypes && <ErrorTypes />}
                {isSmallScreen &&
                    <CacheProvider value={cacheLtr}>
                        <DrawerStyles anchor='right' open={open} onClose={toggleDrawer(false)}>
                            <div className='close-drawer'>
                                <IconButton onClick={toggleDrawer(false)}>
                                    <Close />
                                </IconButton>
                            </div>
                            <WordsContent {...props} contentToPrint={contentToPrint} />
                        </DrawerStyles>
                    </CacheProvider>
                }
                {!isSmallScreen && <WordsContent {...props} contentToPrint={contentToPrint} />}

                {/* {components?.[footer]} */}
            </WrapScreenMarkWords>
        </WordsContext.Provider>
    )
}

export const WordsContext = React.createContext()
export default Words